import _objectSpread from "/data/jenkins/workspace/wyt-admin/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withKeys as _withKeys, withCtx as _withCtx, createTextVNode as _createTextVNode, mergeProps as _mergeProps, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";

const _hoisted_1 = /*#__PURE__*/_createTextVNode("查询");

const _hoisted_2 = /*#__PURE__*/_createTextVNode("重置");

const _hoisted_3 = /*#__PURE__*/_createTextVNode("新增");

const _hoisted_4 = /*#__PURE__*/_createTextVNode("编辑");

import { getAccountList } from '@/request';
import { ref, watch } from 'vue';
import { getVexTableProps, dateFormat } from '@/config';
import dayjs from 'dayjs';
import AddAccountModal from './component/AddAccountModal.vue';
export default {
  name: 'AccountManage',

  setup(__props) {
    const showAddAccountModal = ref(false);
    const table = ref();
    let form = ref({
      loginName: '',
      startTime: '',
      endTime: ''
    });

    function initForm(source = {
      loginName: '',
      startTime: '',
      endTime: ''
    }) {
      form.value = _objectSpread(_objectSpread({}, form.value), source);
    }

    initForm();
    const tableOptions = getVexTableProps({
      columns: [{
        field: 'loginName',
        title: '账号'
      }, {
        title: '姓名',
        field: 'manageLinkMan'
      }, {
        title: '分管角色',
        field: 'roleName'
      }, {
        title: '备注',
        field: 'note',
        resizable: true
      }, {
        title: '创建时间',
        field: 'createAt',
        width: '200px'
      }, {
        title: '操作',
        field: 'operation',
        fixed: 'right',
        slots: {
          default: 'operation'
        }
      }],
      toolbarConfig: {
        slots: {
          buttons: 'tools'
        }
      },
      proxyConfig: {
        ajax: {
          query: ({
            page
          }) => new Promise(res => {
            getAccountList(_objectSpread({
              page: page.currentPage,
              rows: page.pageSize
            }, form.value)).then(data => {
              res({
                total: data.total,
                result: data.rows.map(i => {
                  i.createAt = dayjs(i.createAt).format('YYYY-MM-DD HH:mm:ss');
                  return i;
                })
              });
            });
          })
        }
      }
    });

    function search() {
      table.value.commitProxy('reload');
    }

    function reset() {
      initForm();
      table.value.commitProxy('reload');
    }

    function modelSuccess() {
      table.value.commitProxy('reload');
    }

    const editData = ref(null); // 弹窗关闭 清空需要编辑的数据

    watch(() => showAddAccountModal.value, newVal => {
      if (!newVal) {
        editData.value = null;
      }
    }, {
      flush: 'pre'
    }); // 编辑 生成需要编辑数据 显示弹框

    function edit(row) {
      editData.value = {
        loginName: row.loginName,
        manageLinkMan: row.manageLinkMan,
        ManagerRole: row.roleId != null ? String(row.roleId) : '2',
        note: row.note,
        supUserId: row.supUserId
      };
      showAddAccountModal.value = true;
    }

    return (_ctx, _cache) => {
      const _component_el_input = _resolveComponent("el-input");

      const _component_el_form_item = _resolveComponent("el-form-item");

      const _component_el_date_picker = _resolveComponent("el-date-picker");

      const _component_el_form = _resolveComponent("el-form");

      const _component_el_button = _resolveComponent("el-button");

      const _component_el_row = _resolveComponent("el-row");

      const _component_vxe_grid = _resolveComponent("vxe-grid");

      return _openBlock(), _createElementBlock("div", null, [_createVNode(_component_el_form, {
        inline: true
      }, {
        default: _withCtx(() => [_createVNode(_component_el_form_item, {
          label: "账号",
          onKeydown: _cache[1] || (_cache[1] = _withKeys($event => table.value.commitProxy('reload'), ["enter"]))
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            modelValue: _unref(form).loginName,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _unref(form).loginName = $event)
          }, null, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          label: "开始时间"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_date_picker, {
            modelValue: _unref(form).startTime,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => _unref(form).startTime = $event),
            type: "date",
            "value-format": _unref(dateFormat),
            placeholder: "开始时间"
          }, null, 8, ["modelValue", "value-format"])]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          label: "结束时间"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_date_picker, {
            type: "date",
            modelValue: _unref(form).endTime,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => _unref(form).endTime = $event),
            "value-format": _unref(dateFormat),
            placeholder: "结束时间"
          }, null, 8, ["modelValue", "value-format"])]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_component_el_row, {
        justify: "end"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_button, {
          type: "primary",
          icon: "Search",
          onClick: search
        }, {
          default: _withCtx(() => [_hoisted_1]),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          icon: "Refresh",
          onClick: reset
        }, {
          default: _withCtx(() => [_hoisted_2]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_component_vxe_grid, _mergeProps({
        ref_key: "table",
        ref: table
      }, _unref(tableOptions)), {
        tools: _withCtx(() => [_createVNode(_component_el_button, {
          icon: "Plus",
          type: "primary",
          onClick: _cache[4] || (_cache[4] = $event => showAddAccountModal.value = true)
        }, {
          default: _withCtx(() => [_hoisted_3]),
          _: 1
        })]),
        operation: _withCtx(({
          row
        }) => [_createVNode(_component_el_button, {
          type: "primary",
          icon: "Edit",
          onClick: $event => edit(row)
        }, {
          default: _withCtx(() => [_hoisted_4]),
          _: 2
        }, 1032, ["onClick"])]),
        _: 1
      }, 16), _createVNode(AddAccountModal, {
        modelValue: showAddAccountModal.value,
        "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => showAddAccountModal.value = $event),
        onSuccess: modelSuccess,
        editData: editData.value
      }, null, 8, ["modelValue", "editData"])]);
    };
  }

};